import React,{useState} from 'react';
import { Outlet, useNavigate ,Navigate} from "react-router-dom";
import { isLoggedIn } from '../../../auth';
const Admin = ()=>{
   return isLoggedIn()?<Outlet/>:<Navigate to="/"/>
}
export default Admin;
